import { Box } from "@mui/material";
import styled from "styled-components";

export const ModalReset = styled(Box)`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-width: 40vw;
    min-height: 50vh ;
    background-color: #FFFFFF;
    border-radius: 10px;
    box-shadow: 24;
    padding: 20px ;

    #modal-modal-title{
        margin-bottom: 10px;
        width: 100% ;
        display: flex;
        flex-direction: row;
        justify-content: space-between ;
    }

    .reset-password{
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .options {
        margin-top: 40px ;
        width: 100% ;
        display: flex ;
        flex-direction: row ;
        justify-content: center ;

        .btnOption {
            margin-left: 10px ;
            margin-right: 10px;
        }
    }
`;